export default __webpack_public_path__ + "static/media/fw-angela-er-White Gold.b0ec0cda.mp4";